// @flow

import ApiObject from '../ApiObject';

// -- constants
import BookingConstants from '../../constants/BookingConstants';

// -- entities

export default class BookingSettingsRoom extends ApiObject {

  /**
   * Id of the room. Defined by the front.
   */
  id: string = '';

  /**
   * The room name. Ex: Patio
   */
  name: string = '';

}



// WEBPACK FOOTER //
// ./sdk/scripts/entities/booking/BookingSettingsRoom.js